import { render } from "./ReassignManifestShipmentRoute.vue?vue&type=template&id=5f963b62&scoped=true"
import script from "./ReassignManifestShipmentRoute.vue?vue&type=script&lang=js"
export * from "./ReassignManifestShipmentRoute.vue?vue&type=script&lang=js"

import "./ReassignManifestShipmentRoute.vue?vue&type=style&index=0&id=5f963b62&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f963b62"]])

export default __exports__